import { useApp, useTranslation } from "@next-platform/client-common-core";
import { Filter } from "@next-platform/client-common-spicy-ui";
import type { SearchResults } from "algoliasearch-helper";
import React from "react";

import { FilterWrapper } from "@/components/search/FilterWrapper";
import Trans from "@/components/Trans/Trans";

import { FilterOperator } from "./types";
import useTagFilter from "./useTagFilter";

interface IFilterBoxLorebookProps {
  operator: FilterOperator;
  useStoreTagFilters: boolean;
  isLoading: boolean;
  isAuthenticated: boolean;
  results: SearchResults | undefined;
  isTagsDrawerVisible: boolean;
  setIsTagsDrawerVisible: (value: boolean) => void;
  isDesktop: boolean;
  isTagListMinimized: boolean;
}

const FilterBoxLorebook = ({
  operator,
  useStoreTagFilters = true,
  isLoading,
  isAuthenticated,
  results,
  isTagsDrawerVisible,
  setIsTagsDrawerVisible,
  isDesktop,
  isTagListMinimized,
}: IFilterBoxLorebookProps) => {
  const { t } = useTranslation();
  const { lorebookTagOptions } = useApp();
  // Lorebook facets must be filtered against the lorebook vocabulary, not the chatbot one.
  const { tagsListData, tagsActionHandler } = useTagFilter({
    operator,
    results,
    useStoreTagFilters,
    isAuthenticated,
    isLoading,
    allowedTagsOverride: lorebookTagOptions,
  });

  if (isDesktop && isTagListMinimized) {
    return null;
  }

  return (
    <FilterWrapper open={isTagsDrawerVisible} onOpenChange={setIsTagsDrawerVisible} isDesktop={isDesktop}>
      <div className="flex flex-col gap-2.5 h-full w-full">
        <Filter isOpen={true} data={tagsListData} actionHandler={tagsActionHandler}>
          <Filter.Header>
            <Filter.Title>
              <Trans i18nKey="chatbotFilters:filterByTag.title" />
            </Filter.Title>
            <Filter.Reset alwaysShow>
              <Trans i18nKey="common:reset" />
            </Filter.Reset>
          </Filter.Header>
          <Filter.Search children={t("chatbotFilters:filterByTag.placeholder")} />
          <Filter.Body hasExclude />
        </Filter>
      </div>
    </FilterWrapper>
  );
};

export default React.memo(FilterBoxLorebook);
